export type Theme = "light" | "dark";
const KEY = "cx.theme";

/** localStorage pode lançar SecurityError (armazenamento bloqueado): o tema claro é o padrão (FE17). */
export function readTheme(): Theme {
  try {
    return localStorage.getItem(KEY) === "dark" ? "dark" : "light";
  } catch {
    return "light";
  }
}
export function saveTheme(t: Theme) {
  try {
    localStorage.setItem(KEY, t);
  } catch {
    // sem armazenamento: o tema vale só nesta aba
  }
}
export function applyTheme(t: Theme) {
  document.documentElement.dataset.bsTheme = t;
}
